module.exports = __webpack_public_path__ + "assets/img/right_4.97612d13.png";